import { ZScoreBarColors } from "./types";

export const zScoreBarColors: ZScoreBarColors = {
  profits: "linear-gradient(to right, #0e272e, #2acbfe 47%, #0ceaae 88%)",
  risk: "linear-gradient(to right, #210f45, #5533cf, #50a9ee)",
  service: "linear-gradient(to right, #1f1030, #6d0b82 42%, #dd4393 76%, #f24196)",
  balanced: "linear-gradient(to right, #10341d, #46995c 42%, #76dd88 76%, #88c489)",
};
